import { render, staticRenderFns } from "./address-info.vue?vue&type=template&id=57e7cec0&scoped=true&"
import script from "./address-info.vue?vue&type=script&lang=js&"
export * from "./address-info.vue?vue&type=script&lang=js&"
import style0 from "./address-info.vue?vue&type=style&index=0&id=57e7cec0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e7cec0",
  null
  
)

export default component.exports